import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-download-app',
    templateUrl: './block-download-app.component.html',
})

export class BlockDownloadAppComponent extends BlockAbstractComponent implements OnInit {

}
